// extracted by mini-css-extract-plugin
export var button = "style-module--button--c26f7";
export var iamnetconsent = "style-module--iamnetconsent--337d5";
export var iamnetconsentactionarea = "style-module--iamnetconsentactionarea--1ee3d";
export var iamnetconsentfullblock = "style-module--iamnetconsentfullblock--0eba0";
export var iamnetconsenticonmode = "style-module--iamnetconsenticonmode--751dd";
export var iamnetconsentqrcode = "style-module--iamnetconsentqrcode--5c2cb";
export var iamnetconsenttext = "style-module--iamnetconsenttext--8f305";
export var iamnetconsenttextbody = "style-module--iamnetconsenttextbody--86d58";
export var link = "style-module--link--47d7f";